import { ColorEnum } from '@/constants/color'
import { FC, ReactNode } from 'react'
import { StyleSheet, View } from 'react-native'

interface ItemProps {
    children: ReactNode
}

const Item: FC<ItemProps> = ({ children }) => {
    return <View style={styles.item}>{children}</View>
}

const styles = StyleSheet.create({
    item: {
        maxWidth: 680,
        width: '100%',
        padding: 20,
        alignItems: 'center',
        gap: 16,
        borderRadius: 8,
        backgroundColor: ColorEnum.GRAY_100,
        borderWidth: 1,
        borderColor: ColorEnum.GRAY_300,
    },
})

export default Item
